## html
<div class="node {{ type || '' }}" style="transform: translate3d({{ x }}px, {{ y }}px, 0px)">
	<sf-template path="Blackprint/nodes/template/routes.sf"></sf-template>
	<sf-template path="Blackprint/nodes/template/header.sf"></sf-template>

	<div class="content">
		<div class="left-port">
			<sf-template path="Blackprint/nodes/template/input-port.sf"></sf-template>
		</div>
		<div class="right-port">
			<sf-template path="Blackprint/nodes/template/output-port.sf"></sf-template>
		</div>

		<div class="section-split" style="{{ hasInterfaceContent ? '' : 'display: none' }}"></div>

		<div class="container">
			<div sf-each="val in _interfaces" class="{{ val.type }}" style="display: {{ val.inline ? 'inline-block' : 'block' }}">
       		{{@exec
				if(val.label){
					if(val.inline)
						{[ <label>{{ val.label }} </label> ]};
					else
						{[ <label>{{ val.label }}: </label> ]};
				}

				if(val.type === 'text_in' || val.type === 'text_out')
					{[ <textarea style="width: 99%" placeholder="{{ val.placeholder || '' }}" title="{{ val.tooltip || '' }}"></textarea> ]};
				else if(val.type === 'picture_in')
					{[ <div class="img"><div class="label">{{ val.placeholder || "Drag and drop picture here..." }}</div><img title="{{ val.tooltip || '' }}"></img></div> ]};
				else if(val.type === 'picture_out')
					{[ <div class="img"><div class="label">{{ val.placeholder || "Picture will be displayed here..." }}</div><img title="{{ val.tooltip || '' }}"></img></div> ]};
				else if(val.type === 'media_out')
					{[ <div class="media">
						<img style="display: none" title="{{ val.tooltip || '' }}"></img>
						<video style="display: none" title="{{ val.tooltip || '' }}" controls></video>
						<audio style="display: none" title="{{ val.tooltip || '' }}" controls></audio>
					</div> ]};
				else if(val.type === 'checkbox_in')
					{[ <input type="checkbox" title="{{ val.tooltip || '' }}"></input> ]};
				else if(val.type === 'led_out')
					{[ <div class="led" title="{{ val.tooltip || '' }}"></div> ]};
				else if(val.type === 'dropdown_in' && val.multiple)
					{[ <select multiple title="{{ val.tooltip || '' }}"></select> ]};
				else if(val.type === 'dropdown_in' && !val.multiple)
					{[ <select title="{{ val.tooltip || '' }}"></select> ]};
				else if(val.type === 'file_in' && val.multiple)
					{[ <input type="file" multiple title="{{ val.tooltip || '' }}"></input> ]};
				else if(val.type === 'file_in' && !val.multiple)
					{[ <input type="file" title="{{ val.tooltip || '' }}"></input> ]};
				else if(val.type === 'file_out')
					{[ <button title="{{ val.tooltip || '' }}">{{ val.text || 'Download' }}</button> ]};
				else if(val.type === 'button_in')
					{[ <button title="{{ val.tooltip || '' }}">{{ val.text || 'Button' }}</button> ]};
				else throw new Error(`Type is not recognized: ${val.type}`);
			}}
			</div>
		</div>
	</div>

	<sf-template path="Blackprint/nodes/template/other.sf"></sf-template>
</div>

## scss-global
sf-space[blackprint] bpic-bpremote-PuppetNode .node {
	.container {
		text-align: center;
		max-width: 400px;
	}
	.section-split{
		width: 100%;
		height: 1px;
		padding-top: 7px;
		border-bottom: 1px dashed white;
		display: flex;
	}
	label {
		margin: 5px 5px 2px 5px;
		color: white;
		display: inline-block;
		font-size: 14px;
	}
	textarea {
		margin: 0px;
	}
	button {
		background: #0000008c;
		border: 2px solid #ffffff6b;
		margin: 3px;
		padding: 2px 8px;
		border-radius: 50px;
		outline: none;
		color: white;
		cursor: pointer;
		&:hover{
			background: #9191918c;
		}
	}
	input {
		vertical-align: middle;
	}
	.media{
		img, video, audio{
			max-width: 100%;
			max-height: 250px;
			text-align: center;
			justify-self: center;
			position: relative;
			vertical-align: -webkit-baseline-middle;
		}
	}
	.img{
		position: relative;
		margin: 0 auto;
		width: 250px;
		min-height: 100px;
		background: black;
		border-radius: 10px;
		overflow: hidden;
		.label {
			font-size: 8px;
			text-align: center;
			top: 5px;
			position: absolute;
			width: 100%;
			color: gray;
		}
	}
	img{
		height: 100%;
		max-width: 100%;
		max-height: 250px;
		text-align: center;
		visibility: hidden;
		position: relative;
		vertical-align: -webkit-baseline-middle;
		&[src]{
			visibility: visible;
		}
	}
	.text_in, .text_out, .checkbox_in, .dropdown_in, .file_in {
		text-align: left;
	}
	.checkbox_in, .dropdown_in, .file_in {
		margin: 5px 0 5px 0;
	}
	.picture_in, .picture_out {
		margin-bottom: 2px;
	}
	.picture_in, .picture_out, .file_out, .button_in {
		label{
			display: block;
		}
	}
	.led_out {
		margin: 0 3px;
		.led {
			background: gray;
			margin: 5px auto;
			height: 15px;
			width: 15px;
			border-radius: 15px;
			text-align: center;
			&.inactive { background: #c93f3f; }
			&.active { background: green; }
		}
	}
}

## js-global
Blackprint.Sketch.registerInterface("BPIC/BPRemote/PuppetNode", {
	template: #this.path,
}, class extends Blackprint._IPuppetNode {
	constructor(node){
		super(node);
		this._interfaces = {};
		this.data = {};
		this.hasInterfaceContent = false;

		// text_out, text_in, picture_out, picture_in, file_out, file_in, button_in
		this.interfaceSync = node.constructor.interfaceSync || [
			/* {type: "text_out", id: "log", placeholder: "Output log", tooltip: "aaa"},
			{type: "text_in", id: "input", placeholder: "Type text here..."},
			{type: "picture_out", id: "pic_out", tooltip: "Picture preview"},
			{type: "picture_in", id: "pic_in", tooltip: "Picture input"},
			{type: "media_out", id: "media_out", tooltip: "Media preview", optional: true},
			{type: "checkbox_in", id: "checkbox_in", tooltip: "Enable/disable"},
			{type: "led_out", id: "led_out", tooltip: "Status indicator", inline: true},
			{type: "dropdown_in", id: "dropdown_in", tooltip: "List selection", options: [
				{id: 'aa', text: 'AA'},
				{id: 'bb', text: 'BB'},
			], multiple: false},
			{type: "file_in", id: "file_in", tooltip: "File input"},
			{type: "file_out", id: "file_out", tooltip: "File download", inline: true},
			{type: "button_in", id: "button_in", tooltip: "Button input", text: 'Button', inline: true},

			{type: "text_in", port_input: "StringField", default: "..."},
			{type: "number_in", port_input: "IntegerField", default: 0},
			{type: "checkbox_in", port_input: "BooleanField", default: true},
			{type: "button_in", port_output: "TriggerField"},
			*/
		];
		this._interfaceSync = {};
	}
	init(){
		let sync = this.interfaceSync;
		let _interfaces = this._interfaces;
		let optional_out = this.data.optional_out ?? {};

		for (let i=0; i < sync.length; i++) {
			let temp = sync[i];
			this._interfaceSync[temp.id] = temp;

			if(temp.id != null) {
				sf.Obj.set(_interfaces, temp.id, temp);
				this.hasInterfaceContent = true;

				if(temp.optional === true) {
					optional_out = this.data.optional_out ??= {};

					let enabled = optional_out[temp.id] ??= false;
					if(enabled) this.node.syncOut(temp.id, {request: true});
					_interfaces.$el(temp.id).css('display', enabled ? '' : 'none');
				}

				if(temp.type === 'text_in'){
					_interfaces.$el('textarea', temp.id).on('input', ev => {
						this.syncOut(temp.id, ev.target.value);
					});
				}
				else if(temp.type === 'picture_in'){
					let el = _interfaces.$el('.img', temp.id);
					el.on('dragover', ev => ev.preventDefault());
					el.on('drop', ev => {
						ev.preventDefault();

						let file = ev.dataTransfer.files[0];
						if(!(file instanceof File))
							throw new Error("Dropped item in this element was not a file");

						this._encodeFile(file).then(v => {
							this.syncOut(temp.id, { url: 'data:image;base64,'+btoa(v) });
						});

						let FR = new FileReader();
						FR.addEventListener("load", ev => el.find('img')[0].src = ev.target.result);
						FR.readAsDataURL(file);
					});
				}
				else if(temp.type === 'checkbox_in'){
					_interfaces.$el('input', temp.id).on('input', ev => {
						this.syncOut(temp.id, ev.target.checked);
					});
				}
				else if(temp.type === 'dropdown_in'){
					let el = _interfaces.$el('select', temp.id);
					el.on('input', ev => {
						this.syncOut(temp.id, {selected: [...ev.target.selectedOptions].map(v => v.value)});
					});

					let options = temp.options;
					for (let i=0; i < options.length; i++) {
						let item = options[i];
						el.append(`<option value="${$.escapeText(item.id)}">${$.escapeText(item.text)}</option>`);
					}
				}
				else if(temp.type === 'file_in'){
					_interfaces.$el('input', temp.id).on('input', ev => {
						Promise.all([...ev.target.files].map(v => this._encodeFile(v))).then(v => {
							this.syncOut(temp.id, { data: v });
						});
					});
				}
				else if(temp.type === 'file_out'){
					let el = _interfaces.$el('button', temp.id);
					el.on('click', ev => {
						let fileData = el[0].fileData;
						if(fileData == null)
							throw new Error("No downloadable content");

						let blob = new Blob([fileData], { type: 'application/octet-stream' });

						let temp = document.createElement('a');
						temp.href = URL.createObjectURL(blob);
						temp.download = temp.filename || 'file';
						temp.style = 'display:none';
						document.body.appendChild(temp);
						temp.target = '_blank';
						temp.click();
						temp.remove();

						setTimeout(()=> URL.revokeObjectURL(temp.href), 10000);
					});
				}
				else if(temp.type === 'button_in'){
					_interfaces.$el('button', temp.id)
						.on('pointerdown', ev => {
							this.syncOut(temp.id, {press: true});
						})
						.on('pointerup', ev => {
							this.syncOut(temp.id, {press: false});
						});
				}
			}
			else if(temp.port_input != null || temp.port_output != null) {
				let type;
				let componentName;

				if(temp.type === 'button_in') { type = Function; componentName = 'comp-port-button'; }
				else if(temp.type === 'text_in') { type = String; componentName = 'comp-port-textarea'; }
				else if(temp.type === 'string_in') { type = String; componentName = 'comp-port-input'; }
				else if(temp.type === 'number_in') { type = Number; componentName = 'comp-port-input'; }
				else if(temp.type === 'checkbox_in') { type = Boolean; componentName = 'comp-port-input'; }
				else throw new Error(`Type "${temp.type}" is not supported`);

				let port;
				if(temp.port_input != null) port = this.input[temp.port_input];
				else if(temp.port_output != null) port = this.output[temp.port_output];

				let data = {
					id: temp.port_input || temp.port_output,
					which: temp.port_input ? 'input' : 'output',
					call: type === Function ? 0 : -1,
				};

				let item = port._boxInput = {
					value: temp.default,
					inline: temp.inline,
					visible: port.cables.length === 0,
					type,
				};

				if(type === Function){
					item.onClick = ev => {
						data.call = 1;
						this.syncOut('bp_port_default', data);
					}
				}
				else {
					let debouncer = ()=> {
						if(type !== Function) data.value = port.default;
						this.syncOut('bp_port_default', data);
					};

					let _debounce;
					item.whenChanged = (now) => {
						clearTimeout(_debounce);
						_debounce = setTimeout(debouncer, 700);
						return port.default = now;
					};
				}

				port.insertComponent(null, componentName, item);
				port._hasComponent = false; // reset the flag as this was internal component
			}
			else throw new Error("Every 'interfaceSync' require an 'id' or 'port_input' or 'port_output', but one of the interface haven't been specified yet");
		}

		this.on('node.menu', ev => {
			let switchOptional = id => {
				let enabled = optional_out[id] ??= false;
				enabled = optional_out[id] = !enabled;

				if(enabled) this.syncOut(id, {request: enabled});
				_interfaces.$el(id).css('display', enabled ? '' : 'none');
			}

			let deep = [];
			for (let key in optional_out) {
				deep.push({ title: (optional_out[key] ? 'Disable: ' : 'Enable: ') + key, callback(){ switchOptional(key) } });
			}

			if(deep.length !== 0) ev.menu.push({
				title: "Remote Preview",
				deep
			});
		});
	}
	async _encodeFile(file){
		file = await file.arrayBuffer();

		let encoded = '';
		let bytes = new Uint8Array(file);

		for (let i = 0, n = bytes.byteLength; i < n; i++)
			encoded += String.fromCharCode(bytes[i]);

		return encoded;
	}
	imported(data){
		if(!data) return;

		let sync = this._interfaceSync;
		if(sync) for (let key in sync) {
			let temp = sync[key];
			let val = data[key];
			if(temp.save && val != null){
				if(temp.type === 'text_in') this._interfaces.$el('textarea', temp.id).val(val); // value
				if(temp.type === 'checkbox_in') this._interfaces.$el('input', temp.id).val(val); // checked
				if(temp.type === 'dropdown_in') this._interfaces.$el('select', temp.id).val(val); // selectedOptions
			}
		}
	}
	syncIn(id, data){
		let item = this._interfaces[id];
		if(item == null) return; // Skip node data sync from remote

		if(item.type === 'text_out')
			this._interfaces.$el('textarea', id).val(data);
		else if(item.type === 'picture_out')
			this._interfaces.$el('img', id).attr('src', data.url);
		else if(item.type === 'media_out'){ // ToDo: Optimize performance for code below
			let img = this._interfaces.$el('img', id);
			let video = this._interfaces.$el('video', id);
			let audio = this._interfaces.$el('audio', id);
			URL.revokeObjectURL(img.attr('src'));
			URL.revokeObjectURL(video.attr('src'));
			URL.revokeObjectURL(audio.attr('src'));

			let url = URL.createObjectURL(new Blob([data.data], { type: data.mimeType }));
			if(data.mimeType.startsWith('image/')){
				img.attr('src', url).css('display', 'block');
				video.css('display', 'none');
				audio.css('display', 'none');
			}
			else if(data.mimeType.startsWith('video/')){
				video.attr('src', url).css('display', 'block');
				img.css('display', 'none');
				audio.css('display', 'none');
			}
			else if(data.mimeType.startsWith('audio/')){
				audio.attr('src', url).css('display', 'block');
				img.css('display', 'none');
				video.css('display', 'none');
			}
			else URL.revokeObjectURL(url);
		}
		else if(item.type === 'checkbox_in')
			this._interfaces.$el('input', id)[0].checked = data.active;
		else if(item.type === 'dropdown_in'){
			if(data.type === 'list'){
				let el = this._interfaces.$el('select', id);
				el[0].textContent = '';

				let options = data.options;
				for (let i=0; i < options.length; i++) {
					let item = options[i];
					el.append(`<option value="${$.escapeText(item.id)}">${$.escapeText(item.text)}</option>`);
				}
			}
			else if(data.type === 'selected'){
				let el = this._interfaces.$el('select', id);
				let list = el.find('option');
				let index = -1;

				for (let i=0; i < list.length; i++) {
					if(list[i].value === data.id){
						index = i;
						break;
					}
				}

				if(index === -1)
					return console.error(`Id "${data.id}" was not found in dropdown "${id}" list on node "${this.iface.namespace}"`);

				el[0].selectedIndex = index;
			}
		}
		else if(item.type === 'led_out'){
			let div = this._interfaces.$el('div', id);
			div.removeClass(data.active ? 'inactive' : 'active');
			div.addClass(data.active ? 'active' : 'inactive');
		}
		else if(item.type === 'file_out'){
			let temp = data.data;
			let bytes = new Uint8Array(temp.length);
			for (var i = 0; i < temp.length; i++)
				bytes[i] = temp.charCodeAt(i);

			this._interfaces.$el('button', id)[0].fileData = bytes;
		}
	}
	syncOut(id, data){
		let sync = this._interfaceSync[id];
		if(sync.save) this.data[id] = data;
		this.node.syncOut(id, data);
	}
});